import { defaultPaddingLeft, defaultPaddingTop, mobileDefaultPadding } from 'constants/sizes';
import Device from 'constants/deviceSizes';
import { appConfig } from 'config/customization';

export default {
  container: {
    width: '100%',
    boxSizing: 'border-box',
    padding: `${defaultPaddingTop}px ${defaultPaddingLeft}px`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'justify',
    [Device.mobile]: {
      padding: mobileDefaultPadding
    }
  },
  activeRowStyle: {
    backgroundColor: appConfig.colors.activeRowColor,
    boxShadow: 'inset -2px 73px 46px -87px rgba(0,0,0,1)'
  },
  bulletsSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%'
  },
  withBorder: {
    borderBottom: `2px solid ${appConfig.colors.activeRowColor}`
  },
  bullet: {
    padding: '10px 0px',
    textAlign: 'left'
  },
  bulletsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    paddingTop: 11
  },
  contactSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%'
  },
  contactItems: {
    display: 'flex',
    justifyContent: 'space-around',
    width: '100%',
    boxSizing: 'border-box',
    paddingTop: 11,
    [Device.mobile]: {
      flexDirection: 'column'
    }
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
    [Device.mobile]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  addComplaint: {
    [Device.mobile]: {
      marginTop: 10
    }
  }
};
